import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_287: DocMigration = {
  maxSchemaVersion: "0.0.287",
  description: "Set SettingsSetBehaviorType for all existing settings sets to PUSH",
  apply(json: any): any {
    json.entitySettings = json.entitySettings || {};

    for (const id in json.settingsSets) {
      json.settingsSets[id] = {
        ...json.settingsSets[id],
        type: "PUSH",
      };
    }

    return json;
  },
};

export default migration_0_0_287;
